import React from "react";
import { utils, writeFile } from "xlsx-js-style";
import CustomInput from "../components/formik/CustomInput";
import {
  ServiceBackground,
  ServiceConact,
} from "../components/reports/ServiceColumn";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import {
  getCurrentFortnightName,
  getOrderType,
  getReason,
} from "../models/ReportOperatorSalary";
import CustomSelect from "../components/formik/CustomSelect";

const OrdersPaymentsInvoicesForm = ({
  formik,
  records,
  status,
  paymentTypes,
  vehicleTypes,
}) => {
  const baseUrl = window.location.origin;

  const exportToExcel = () => {
    const workbook = utils.book_new();
    const sheetName = "Órdenes";
    const sheetData = [
      [
        "Folio",
        "Descripción del servicio",
        "Tipo de Servicio",
        "Tipo de Vehículo",
        "Fecha",
        "Total (Sin IVA)",
        "Razón",
        "Total Facturas",
        "Total Pagos",
      ],
    ];

    let totalSubtotal = 0;
    let totalInvoices = 0;
    let totalPayments = 0;

    const ordersArray = Array.isArray(records) ? records : [];
    console.log(ordersArray);

    ordersArray.forEach((Order) => {
      const bg = ServiceBackground({ row: Order });
      const orderType =
        Order.tipoServicio != null ? Order.tipoServicio : getOrderType(Order);

      const subtotal = Number(Order.subtotal) || 0;
      const invoices = Number(Order.totalFacturas) || 0;
      const payments = Number(Order.totalPagos) || 0;
      const reason = Order.razon?.trim() ? Order.razon : getReason(Order);

      // Obtener tipo de vehículo
      const tipoVehiculo =
        Order?.tipo === "Varo Express"
          ? Order?.vehicles
              ?.map(v => v.VehicleModel?.VehicleType?.vehicle_type_name)
              .filter(Boolean)
              .join(", ") || "N/A"
          : Order?.vehicles
              ?.map(v => v.type)
              .filter(Boolean)
              .join(", ") || "N/A";


      sheetData.push([
        {
          t: "s",
          v: Order.folio.toString().padStart(5, "0"),
          l: {
            Target:
              Order.tipo === "Varo Express"
                ? `${baseUrl}/orders-vial/editOrder/${Order.order_id}`
                : `${baseUrl}/orders/edit/${Order.order_id}`,
          },
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: orderType,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: ServiceConact({ row: Order }),
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: tipoVehiculo, 
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: format(new Date(Order.fecha_hora_reporte), "dd/MMM/yyyy", {
            locale: es,
          }),
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: subtotal,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: reason,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: invoices,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: payments,
          s: { fill: { fgColor: { rgb: bg } } },
        },
      ]);

      totalSubtotal += subtotal;
      totalInvoices += invoices;
      totalPayments += payments;
    });

    sheetData.push([{ t: "s", v: "" }]); // Fila vacía

    sheetData.push([
      { t: "s", v: "Total" },
      { t: "s", v: "" },
      { t: "s", v: "" },
      { t: "s", v: "" },
      { t: "s", v: "" },
      { t: "n", v: totalSubtotal },
      { t: "s", v: "" },
      { t: "n", v: totalInvoices },
      { t: "n", v: totalPayments },
    ]);

    const worksheet = utils.aoa_to_sheet(sheetData);
    worksheet["!cols"] = [
      { wch: 20 }, // Folio
      { wch: 35 }, // Descripción
      { wch: 20 }, // Tipo Servicio
      { wch: 25 }, // Tipo Vehículo
      { wch: 30 }, // Fecha
      { wch: 20 }, // Subtotal
      { wch: 35 }, // Razón
      { wch: 20 }, // Facturas
      { wch: 20 }, // Pagos
    ];

    utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, getCurrentFortnightName() + ".xlsx");
  };

  return (
    <React.Fragment>
      <div className="row align-items-end gx-1">
        <CustomInput
          label="Fecha inicio (Orden)"
          field="start"
          type="date"
          formik={formik}
          sm={2}
        />
        <CustomInput
          label="Fecha fin (Orden)"
          field="end"
          type="date"
          formik={formik}
          sm={2}
        />

        {/* inputs de rango de fecha de pagos */}
        {/* <CustomInput
          label="Pago desde"
          field="paymentStart"
          type="date"
          formik={formik}
          sm={2}
        />
        <CustomInput
          label="Pago hasta"
          field="paymentEnd"
          type="date"
          formik={formik}
          sm={2}
        /> */}

        {/* inputs de rango de fecha de facturas */}
        {/* <CustomInput
          label="Factura desde"
          field="invoiceStart"
          type="date"
          formik={formik}
          sm={2}
        />
        <CustomInput
          label="Factura hasta"
          field="invoiceEnd"
          type="date"
          formik={formik}
          sm={2}
        /> */}
      {formik.values.companyType === "Gruas Varo" && (
        <CustomSelect
          label="Estatus orden"
          field="status"
          formik={formik}
          options={status}
          required
          sm={2}
        />
       )}
        <CustomSelect
          label="Tipo de pago"
          field="paymentTypes"
          formik={formik}
          options={paymentTypes}
          required
          sm={2}
        />

        {/* <CustomSelect
          label="Plataforma"
          field="companyType"
          formik={formik}
          options={[
            { value: "all", label: "Todas" },
            { value: "Gruas Varo", label: "Gruas Varo" },
            { value: "Varo Express", label: "Varo Express" },
          ]}
          required
          sm={2}
        /> */}

        {/* Filtro por tipo de vehículo */}
        <CustomSelect
          label="Tipo de vehículo"
          field="vehicleTypeId"
          formik={formik}
          options={vehicleTypes}
          required
          sm={2}
        />

        <div className="col-sm-2 d-flex gap-2">
          <button
            className="btn btn-primary w-50"
            onClick={() => formik.handleSubmit()}
          >
            <i className="fa-solid fa-magnifying-glass" />
            &nbsp;Buscar
          </button>
          <button
            className="btn btn-success w-50"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel" />
            &nbsp;Descargar
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrdersPaymentsInvoicesForm;
